import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { isUndefined } from 'lodash-es'

import Tooltip from 'antd/lib/tooltip'
import 'antd/lib/tooltip/style/css'

import './TooltipComponent.scss'

const body = document.querySelector('body')

class TooltipComponent extends React.Component {
  constructor(props) {
    super(props)

    this.getPopupContainer = this.getPopupContainer.bind(this)
  }

  componentWillUnmount() {
    if (!isUndefined(this.tooltipRoot)) {
      body.removeChild(this.tooltipRoot)
    }
  }

  getPopupContainer() {
    this.tooltipRoot = document.createElement('div')
    this.tooltipRoot.classList.add('antd-component')
    body.appendChild(this.tooltipRoot)
    return this.tooltipRoot
  }

  render() {
    const { children, className, wrapperClassName, ...props } = this.props
    return (
      <Tooltip
        overlayClassName={classnames('tooltip-component', {
          [className]: className,
        })}
        getPopupContainer={this.getPopupContainer}
        {...props}
      >
        <div
          className={classnames('tooltip-wrapper', {
            [wrapperClassName]: wrapperClassName,
          })}
        >
          {children}
        </div>
      </Tooltip>
    )
  }
}

TooltipComponent.propTypes = {
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  wrapperClassName: PropTypes.string,
  visible: PropTypes.bool,
}

TooltipComponent.defaultProps = {
  wrapperClassName: '',
}

export default TooltipComponent
